










































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import TextField from '@/componentsV2/molecules/Inputs/TextField.vue';
import FormHeader from '@/componentsV2/molecules/FormHeader/FormHeader.vue';
import SelectDayOfWeek from '@/components/molecules/SelectDayOfWeek/SelectDayOfWeek.vue';
import HourPeriod from '@/components/molecules/HourPeriod/HourPeriod.vue';
import Checkbox from '@/components/Checkbox/Checkbox.vue';
import SpecialCoinIcon from '@/components/icons/SpecialCoin.vue';
import {
  EOfferRulesName,
  ESpecialOfferRules,
  IOfferLocationItem,
  IOfferMethod,
  SpecialOfferTypeEnum
} from '@/models/offer';
import ClockIcon from '@/components/icons/Clock.vue';
import RenewalFrequency from '@/components/organisms/Offers/RenewalFrequency.vue';

import { IBusinessType } from '@/models/business';
import Redemption from './Redemption.vue';
import flagKeys from '@/constants/flagKeys';
import SwitchBox from '@/componentsV2/molecules/Inputs/SwitchBox.vue';
import segmentIo from '@/utils/segment.io';
import { EDayOfTheWeek, WEEKDAY_INDEXES } from '@/api/OpeningHoursService';
import { IDataOffer } from '../FormOffer.vue';
import { IBusiness } from '@/store/modules/managerTypes';

@Component({
  components: {
    TextField,
    FormHeader,
    ClockIcon,
    Typography,
    SelectDayOfWeek,
    Checkbox,
    HourPeriod,
    RenewalFrequency,
    Redemption,
    SpecialCoinIcon,
    SwitchBox
  }
})
export default class RedemptionRules extends Vue {
  @Prop() errors!: string[];
  @Prop() offerBusiness?: IBusiness;
  @Prop() offer?: IDataOffer;
  @Prop() offerData?: IDataOffer;
  @Prop() transformedLocations!: IOfferLocationItem[];
  @Prop() type!: SpecialOfferTypeEnum;

  EOfferRulesName = EOfferRulesName;
  ESpecialOfferRules = ESpecialOfferRules;

  data = {
    availability: {
      [EOfferRulesName.REDEEMABLE_DAY_RULE]: {
        enabled: !!(
          this.offerData &&
          this.offerData.availability &&
          this.offerData.availability[EOfferRulesName.REDEEMABLE_DAY_RULE]
            .enabled
        ),
        value:
          this.offerData && this.offerData.availability
            ? this.offerData.availability[EOfferRulesName.REDEEMABLE_DAY_RULE]
                .value || ''
            : ''
      },
      [EOfferRulesName.REDEEMABLE_HOUR_RULE]: {
        enabled: !!(
          this.offerData &&
          this.offerData.availability &&
          this.offerData.availability[EOfferRulesName.REDEEMABLE_HOUR_RULE]
            .enabled
        ),
        value:
          this.offerData && this.offerData.availability
            ? this.offerData.availability[EOfferRulesName.REDEEMABLE_HOUR_RULE]
                .value || ''
            : ''
      }
    },
    additionalRules: {
      [ESpecialOfferRules.LIMIT_RULE]: {
        enabled: !!(
          this.offerData &&
          this.offerData.additionalRules &&
          this.offerData.additionalRules[ESpecialOfferRules.LIMIT_RULE].enabled
        ),
        value:
          this.offerData && this.offerData.additionalRules
            ? this.offerData.additionalRules[ESpecialOfferRules.LIMIT_RULE]
                .value || '1'
            : '1'
      },
      [ESpecialOfferRules.RENEWED_RULE]: {
        enabled: !!(
          this.offerData &&
          this.offerData.additionalRules &&
          this.offerData.additionalRules[ESpecialOfferRules.RENEWED_RULE]
            .enabled
        ),
        value:
          this.offerData && this.offerData.additionalRules
            ? this.offerData.additionalRules[ESpecialOfferRules.RENEWED_RULE]
                .value || 'yearly:1'
            : 'yearly:1'
      }
    }
  };

  get tPrefix() {
    return 'offers.form.redemptionRules';
  }

  get shouldShowMethodSelect() {
    return this.business.type === IBusinessType.BOTH;
  }

  get flags() {
    return this.$store.getters['flags/getFlags'];
  }

  get showRedemptionRules() {
    return !this.isBirthday;
  }

  get shouldShowRedemptionSection() {
    if (
      this.business.type === IBusinessType.ONLINE ||
      (this.offerData &&
        this.offerData.redeemMethod &&
        this.offerData.redeemMethod.value === IOfferMethod.ONLINE)
    ) {
      return false;
    }

    return this.locationsAmount > 1;
  }

  get isBirthday() {
    return this.type === SpecialOfferTypeEnum.BIRTHDAY;
  }

  get isHappyHour() {
    return this.type === SpecialOfferTypeEnum.HAPPY_HOUR;
  }

  get locationsAmount() {
    return this.transformedLocations.length;
  }

  get business() {
    const store = this.$store.getters['business/getBusinessInfo'];

    if (store && store.business) {
      return store.business;
    } else {
      return this.offerBusiness || {};
    }
  }

  get shouldShowDiscountCode() {
    if (!this.offerData || !this.offerData.redeemMethod) return false;

    const redeemMethod = this.offerData.redeemMethod.value;

    return (
      redeemMethod === IOfferMethod.ONLINE ||
      redeemMethod === IOfferMethod.BOTH ||
      this.business.type === IBusinessType.ONLINE
    );
  }

  changeRenewal(value: string) {
    this.data.additionalRules[ESpecialOfferRules.RENEWED_RULE].value = value;
  }

  changeRule(enabled: boolean) {
    this.$emit('clearError', ESpecialOfferRules.LIMIT_RULE);
    this.$emit('clearError', ESpecialOfferRules.RENEWED_RULE);

    if (!this.data.additionalRules[ESpecialOfferRules.LIMIT_RULE].value)
      this.data.additionalRules[ESpecialOfferRules.LIMIT_RULE].value = '1';

    this.data.additionalRules[ESpecialOfferRules.LIMIT_RULE].enabled = enabled;
    this.data.additionalRules[
      ESpecialOfferRules.RENEWED_RULE
    ].enabled = enabled;

    segmentIo.track('Toggled Offer Redemption Limit', { Enabled: enabled });
  }

  changedDays(value: number[]) {
    segmentIo.track('Changed Offer Redemption Day', {
      Days: value.map(d => Object.values(EDayOfTheWeek)[d])
    });
    // Selecting every weekday equals "Redeemable on any day": keep the toggle
    // active and store no specific days (value stays empty). Unchecking any day
    // turns the toggle off and persists the explicit day list.
    const allDaysSelected = value.length === WEEKDAY_INDEXES.length;
    this.data.availability[
      EOfferRulesName.REDEEMABLE_DAY_RULE
    ].value = allDaysSelected ? '' : value.join();
    this.data.availability[
      EOfferRulesName.REDEEMABLE_DAY_RULE
    ].enabled = allDaysSelected;
    this.$emit('clearError', 'day-rule');
  }

  changedEnableHour(enabled: boolean) {
    if (this.isHappyHour) {
      this.data.availability[
        EOfferRulesName.REDEEMABLE_HOUR_RULE
      ].enabled = false;
      return;
    }
    segmentIo.track('Toggled Offer Redemption Hour', { Enabled: enabled });
    this.data.availability[
      EOfferRulesName.REDEEMABLE_HOUR_RULE
    ].enabled = enabled;
    this.data.availability[EOfferRulesName.REDEEMABLE_HOUR_RULE].value = '';
  }

  changedEnableDay(enabled: boolean) {
    segmentIo.track('Toggled Offer Redemption Day', { Enabled: enabled });
    this.data.availability[
      EOfferRulesName.REDEEMABLE_DAY_RULE
    ].enabled = enabled;
    this.data.availability[EOfferRulesName.REDEEMABLE_DAY_RULE].value = '';
  }

  updateRedeemableHourRule(time: string, type: 'from' | 'to') {
    const value = this.data.availability[EOfferRulesName.REDEEMABLE_HOUR_RULE]
      .value;
    const arrValue = value.split(',');

    if (!time.includes('--') && arrValue[type === 'from' ? 0 : 1] !== time) {
      segmentIo.track('Changed Offer Redemption Hour', {
        Time: time,
        Type: type
      });
    }

    if (type === 'from') {
      arrValue[0] = time;
      arrValue[1] = arrValue[1] || '';
    } else {
      arrValue[0] = arrValue[0] || '';
      arrValue[1] = time;
    }

    this.data.availability[
      EOfferRulesName.REDEEMABLE_HOUR_RULE
    ].value = arrValue.join(',');
    this.$emit('clearError', 'hour-rule');
  }

  @Watch('data', { deep: true })
  changedData(data: any) {
    this.$emit('input', data);
  }
}
